































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { ProductsApi, Product } from '@/api';
import SensorSuggest from '@/components/form pickers/sensorSuggest.vue';
import ChartAdmin from '@/components/charts/chart-admin.vue';
import Toast from '@/components/display/toast.vue';
import TransceiverSuggest from '@/components/form pickers/transceiverSuggest.vue';

@Component({
	components: {
		secondaryNav,
		ChartAdmin,
		SensorSuggest,
		TransceiverSuggest,
		Toast,
	},
	validations: {
		vats: {
			$each: {
				stirrerSensor: { required },
				volumeSensor: { required },
				vatTempSensor: { required },
				inletTempSensor: { required },
				transceiver: { required },
			},
		},
	},
	mixins: [validationMixin],
})
export default class VatUpdate extends Vue {
	public loading = false;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public product: Product | null = null;
	public vats = [];
	private api: ProductsApi;

	constructor() {
		super();
		this.api = new ProductsApi();
	}

	public vatSelect(index) {
		if (index === 0) {
			for (const vat of this.vats) {
				vat.transceiver = this.vats[0].transceiver;
			}
		}
	}

	public isValid(field) {
		return field && field.$dirty ? !field.$invalid : null;
	}

	//  @Watch('$route', { immediate: true, deep: true })
	public async load() {
		const { productId } = this.$route.params;
		this.loading = true;
		try {
			const { data } = await this.api.getProductById(parseInt(productId, 10), {
				params: {
					include: 'vats,org,vats.sensors.transceiver.site,vats.transceiver.site,transceivers',
				},
			});

			this.vats = data.vats || [];
			this.org = data.org || {};
			this.transceivers = data.transceivers || {};
			this.vats.map(vat => {
				(vat.volumeSensor = vat.sensors.find(
					x => x.type === 'lidarDistance' || x.type === 'radarDistance',
				)),
					(vat.vatTempSensor = vat.sensors.find(x => x.type === 'vatTemp')),
					(vat.inletTempSensor = vat.sensors.find(x => x.type === 'inletTemp')),
					(vat.stirrerSensor = vat.sensors.find(x => x.type === 'stirrer'));
			});
		} catch (e) {
			console.log(e);
			this.product = null;
		} finally {
			this.loading = false;
		}
	}

	public created() {
		this.load();
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		const { productId } = this.$route.params;
		const product: Product = {};
		product.transceivers = [];

		this.vats.map(vat => {
			if (!product.transceivers.some(transceiver => transceiver.id === vat.transceiver.id)) {
				product.transceivers.push({ id: vat.transceiver.id });
			}
		});

		product.vats = [];

		this.vats.map(vat =>
			product.vats.push({
				vatId: vat.id,
				vatSize: vat.sizeString,
				vatType: vat.formula,
				offset: vat.vatOffset,
				transceiverId: vat.transceiver.id,
			}),
		);

		product.vatSensors = [];
		this.vats.map(vat =>
			product.vatSensors.push(
				{
					sensorId: vat.stirrerSensor.id,
					sensorType: 'stirrer',
					vatId: vat.id,
					transceiverId: vat.transceiver.id,
				},
				{
					sensorId: vat.volumeSensor.id,
					sensorType: vat.volumeSensor.type ?? 'lidarDistance',
					vatId: vat.id,
					transceiverId: vat.transceiver.id,
				},
				{
					sensorId: vat.vatTempSensor.id,
					sensorType: 'vatTemp',
					vatId: vat.id,
					transceiverId: vat.transceiver.id,
				},
				{
					sensorId: vat.inletTempSensor.id,
					sensorType: 'inletTemp',
					vatId: vat.id,
					transceiverId: vat.transceiver.id,
				},
			),
		);

		try {
			const response = await new ProductsApi().changeDevice(parseInt(productId, 10), {
				data: product,
			});
		} catch (e) {
			let error;
			console.log(e);
			if (e.response) {
				error = 'Error Signing Off ' + e.response.data.message;
			} else if (e.request) {
				error = 'Error Signing Off, network Error';
			} else {
				error = 'Error Signing Off, unknown Error';
			}
			new Toast().makeToast(error, 'Error Signing Off', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('Successfully Updated Vats', 'Successful Allocation', 'success');
		setTimeout(() => {
			this.submitStatus = 'OK';
			// this.$router.push({ name: 'products.list' });
			this.$router.push({ name: 'products.milk.view', params: { productId } });
		}, 1000);
	}
}
